export default {
  Information_information_detail: '10Web-资讯详情页',
  Information_information_show: '1001Web-显示资讯详情页',
}
